<template>
<li class="cx-list__item">
  <template v-if="items.length == 1 && !forceDropdown">
    <a class="cx-link"
      v-if="items[0] && items[0].link"
      v-bind="bindAttr(items[0])"
      v-on="bindAction(items[0])"
    >
      <span class="cx-link__icon">
        <i :class="icon"></i>
      </span>
      <span>{{label}}</span>
    </a>
  </template>
  <template v-else>
    <cx-dropdown trigger="click, hover" transition="cv-slidedown">
      <div class="cx-link">
        <span class="cx-link__icon">
          <i :class="icon"></i>
        </span>
        <span>{{label}}</span>
      </div>
      <template slot="content">
        <ul class="cx-list cx-list--vertical cx-t01">
          <template v-for="item in items" >
            <li v-if="item && item.link"
              :key="`${item.name}-${item.link}`">
              <component 
                :is="'a'" 
                class="cx-link"
                v-bind="bindAttr(item)"
                v-on="bindAction(item)"
              >{{item.name}}</component>
            </li>
          </template>
        </ul>
      </template>
    </cx-dropdown>
  </template>
</li>
</template>

<script>
export default {
  name: 'sight-map-media-btn',
  props: {
    items: {
      type: [Object, Array],
      default: () => []
    },
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'fas fa-star'
    },
    forceDropdown: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    bindAttr(item) {
      if (this.label != this.$t('media.video')) {
        return {
          href: this.getMediaHost(item.link, 'MGTO'),
          rel: "noreferrer",
          target: "_blank"
        }
      } else {
        return {}
      }
    },
    bindAction(item) {
      if (this.label == this.$t('media.video')) {
        return {
          click: () => this.playVideo(item.name, this.getMediaHost(item.link, 'MGTO'))
        }
      } else {
        return {}
      }
    },
    playVideo(name, src) {
      const modalID = 'tmp-' + (new Date()).getTime();
      ModalManager.create(
        modalID, 
        `<div>
          ${name 
            ? `<h1 style="text-align: left" class="cx-t20 m-title"
              >${name}</h1>` 
            : ""}
          <video style="width: 100%; max-width: 100%;" src="${src}" autoplay controls/>
        </div>`
      ).onClose(function() {
        ModalManager.remove(modalID);
      }).mount().open()
    } 
  }
}
</script>
